import { defineStore } from 'pinia'
import { ref } from 'vue'

const DEFAULT_CATEGORY = 'supportCategoryJsp'

/** Pinia store that preserves contact support form data across navigation */
export const useContactSupportStore = defineStore('contactSupportStore', () => {
    /********************************************************************************************************************
     STATE
     ********************************************************************************************************************/
    const category = ref(DEFAULT_CATEGORY)
    const equipmentSerialNo = ref('')
    const phoneNumber = ref('')
    const subject = ref('')
    const message = ref('')

    /********************************************************************************************************************
     ACTIONS
     ********************************************************************************************************************/
    /** Resets all form fields to their initial values */
    function reset() {
        category.value = DEFAULT_CATEGORY
        equipmentSerialNo.value = ''
        phoneNumber.value = ''
        subject.value = ''
        message.value = ''
    }

    /********************************************************************************************************************
     INTERFACE
     ********************************************************************************************************************/
    return { category, equipmentSerialNo, phoneNumber, subject, message, reset }
})
